import { SetAvailability } from '../containers/SetAvailability/SetAvailability';
import Language from '../components/SidebarOptions/Language/Language';
import Settings from '../components/SidebarOptions/Settings/Settings';
import Sidebar from '../containers/Sidebar/Sidebar';
import { Support } from '../containers/Support/Support';
import { selectUserId } from '../containers/Login/LoginSlice';
import { CreateMessage } from './CreateMessage';
import { CreateMessageNew } from './CreateMessageNew';
import { registerNavigate } from './navigation';
import { EditDocumentsPage } from './EditDocuments';
import ImOk from './ImOk';
import ImOkPage from './ImOkPage';
import { LogNotesPage } from './LogNotes';
import { Login2faPage } from './Login2faPage';
import LoginSkolonPage from './LoginSkolonPage';
import { LoneWorkerTimerCreateAlarmPage } from './LoneWorkerTimerCreateAlarmPage';
import { LoneWorkerTimerPage } from './LoneWorkerTimerPage';
import { LoneWorkerTimerSelectGroupsPage } from './LoneWorkerTimerSelectGroupsPage';
import { MeetingRoomPage } from './MeetingRoomPage';
import OnCallAlert from './OnCallAlert';
import { OnCallAlertMemberSettingsPage } from './OnCallAlertMemberSettings';
import OnCallAlertPage from './OnCallAlertPage';
import AlarmPage from './alarm/alarm';
import AlarmCustomTextPage from './alarm/alarmCustomText';
import AlarmMapPage from './alarm/alarmMap';
import AlarmSelectGroupPage from './alarm/alarmSelectGroup';
import { BroadcastPage } from './broadcast/broadcast';
import { BroadcastNewPage } from './broadcast/broadcastNew';
import { ChangePasswordPage } from './changePassword';
import { ChangeSecondNumberPage } from './changeSecondNumber';
import { ChatMediaPage } from './chat/ChatMediaPage';
import { ChatMessages } from './chat/ChatMessages';
import { ChatMessagesFromHoldingStatement } from './chat/ChatMessagesFromHoldingStatement';
import { ReadReceiptsPage } from './chat/ReadReceipts';
import { ChatPage } from './chat/chat';
import ChatAddGroupsPage from './chat/chatAddGroups';
import ChatDetailsFromHoldingStatementPage from './chat/chatDetailFromHoldingStatment';
import ChatDetailsPage from './chat/chatDetails';
import ForwardPage from './chat/forward';
import { ChatMemberSettings } from './chatMemberSettings';
import ChecklistPage from './checklists/checklist';
import ChecklistEditAccess from './checklists/checklistEditAccess';
import ChecklistsPage from './checklists/checklistsPage';
import CreateChecklistPage from './checklists/createChecklistPage';
import EditChecklistPage from './checklists/editChecklistPage';
import NewChecklistPage from './checklists/newChecklistPage';
import StartChecklistPage from './checklists/startChecklistPage';
import { CreatCecMessagePage } from './creatCecMessage';
import { CreateHoldingStatementPage } from './createHoldingStatement';
import CreateLogNotePage from './createLogNote';
import { DashBoardPage } from './dashBoard';
import { DocumentsPage } from './documents';
import { ExternalContactMessagePage } from './externalContactMessage';
import { ExternalContactsPage } from './externalContacts';
import { ForgetPasswordPage } from './forgetPassword';
import { GroupsPage } from './groups/groupDetails';
import { GroupsListPage } from './groups/groupsList';
import { GroupMemberPage } from './groups/memberSettings';
import { HoldingStatementPage } from './holdingStatement';
import { IAmOkMemberSettingsPage } from './iAmOkMemberSettings';
import { InternalSupportPage } from './internalSupport';
import { LogNotePage } from './logNote';
import { LegacyLoginPage } from './LegacyLoginPage';
import { LoginPage } from './LoginPage';
import { LoginIntroPage } from './LoginIntroPage';
import { NewsPage } from './news';
import { NotFoundPage } from './notFound';
import PanicAlarmCreatePage from './panicButton/PanicAlarmCreatePage';
import PanicAlarmTimerPage from './panicButton/PanicAlarmTimerPage';
import { PanicSelectRecipientsPage } from './panicButton/PanicSelectRecipientsPage';
import { ProfilePage } from './profile';
import { ResetPasswordPage } from './resetPassword';
import { StartIamOkMessagePage } from './startIamOkMessage';
import { StartOnCallAlertMessagePage } from './startOnCallAlertMessage';
import { RecipientGroups } from '../containers/RecipientGroups/RecipientGroups';
import type { LoaderFunctionArgs, RouteObject } from 'react-router-dom';
import {
  createBrowserRouter,
  createHashRouter,
  Outlet,
  useLocation,
  useNavigate,
  defer,
  useLoaderData,
  Await,
} from 'react-router-dom';
import isElectron from 'is-electron';
import { OpenMobileApp } from '../containers/OpenMobileApp/OpenMobileApp';
import { CheckAppAvailable } from '../containers/CheckAppAvailable/CheckAppAvailable';
import { ErrorHandler } from '../components/ErrorHandler/ErrorHandler';
import { App } from '../containers/App/App';
import { AuthApp } from '../containers/App/AuthApp';
import { MapTypeContextProvider } from '../utils/customHooks/MapTypeContext';
import { RequireCookies } from '../components/RequireCookies/RequireCookies';
import { useAppSelector } from '../hooks';
import { Suspense, useEffect } from 'react';
import Splash from '../components/Splash/Splash';
import { resolveAppRegion, setRegion } from '../config/region';
import { getItem } from '../utils/storage';
import { safeParseJwtPayload } from '../utils/jwt';
import { changeBaseUrl, getResolvedApiUrl } from '../apis/utils/provider';
import { TestAlarmPage } from './testAlarm';
import {
  clearPreAddOrgTenantId,
  getPreAddOrgTenantId,
} from '../containers/Organizations/OrganizationsSlice/beginAddOrganization';
import { runAuthRouteLoader, runPublicRouteLoader } from './loaderHelpers';
import DevOptions from '../components/SidebarOptions/DevOptions/DevOptions';

const publicRoutes: RouteObject[] = [
  { path: '/intro/*', element: <LoginIntroPage /> },
  { path: '/', element: <LoginIntroPage /> },
  { path: '/2fa', element: <Login2faPage /> },
  { path: '/login', element: <LoginPage /> },
  { path: '/login/user-pass', element: <LegacyLoginPage /> },
  { path: '/login/user-pass/region', element: <LegacyLoginPage /> },
  { path: '/login/sso', element: <LegacyLoginPage /> },
  { path: '/login/sso/region', element: <LegacyLoginPage /> },
  { path: '/forgetPassword', element: <ForgetPasswordPage /> },
  {
    // TODO: Remove this after current reset password link is expired (i.e after 30 days - approximately 16/6/2025)
    path: '/recover_password/:userId/:resetToken',
    element: <ResetPasswordPage />,
  },
  {
    // TODO: Remove this after current reset password link is expired (i.e after 30 days - approximately 16/6/2025)
    path: '/initial_password/:userId/:resetToken',
    element: <ResetPasswordPage />,
  },
  {
    path: '/recover_password/:userId/:resetToken/:region',
    element: <ResetPasswordPage />,
  },
  {
    path: '/initial_password/:userId/:resetToken/:region',
    element: <ResetPasswordPage />,
  },
  { path: '/sso', element: <LoginPage /> },
  { path: '/skolon_login', element: <LoginSkolonPage /> },
  { path: '*', element: <NotFoundPage /> },
];

const authRoutes: RouteObject[] = [
  {
    path: 'dashboard',
    element: <DashBoardPage />,
  },
  {
    path: '/change_password/*',
    element: <ChangePasswordPage />,
  },
  { path: '/sidebar', element: <Sidebar /> },
  { path: '/change-second-number', element: <ChangeSecondNumberPage /> },
  { path: '/chat', element: <ChatPage /> },
  { path: 'message/:id/forward', element: <ForwardPage /> },
  { path: 'message/:id/read-receipts/:replyId', element: <ReadReceiptsPage /> },
  { path: 'message/:id/media', element: <ChatMediaPage /> },
  { path: '/profile', element: <ProfilePage /> },
  { path: '/groups', element: <GroupsListPage /> },
  { path: '/aloneWorker/create/select-recipients', element: <LoneWorkerTimerSelectGroupsPage /> },
  { path: '/aloneWorker/create', element: <LoneWorkerTimerCreateAlarmPage /> },
  { path: '/aloneWorker/timer', element: <LoneWorkerTimerPage /> },
  { path: '/meeting_room', element: <MeetingRoomPage /> },
  {
    path: '/groups/:id',
    element: <GroupsPage />,
  },
  {
    path: 'groups/:id/memberSettings/:memberID',
    element: <GroupMemberPage />,
  },
  {
    path: 'documents/*',
    element: <DocumentsPage />,
  },
  {
    path: 'documents/:groupDocumentId/:folderId/:type/:selectedFileId',
    element: <EditDocumentsPage />,
  },
  {
    path: 'documents/:groupDocumentId/:type/:selectedFileId',
    element: <EditDocumentsPage />,
  },
  {
    path: 'documents/edit/:type',
    element: <EditDocumentsPage />,
  },
  {
    path: 'documents/edit/:type/:value',
    element: <EditDocumentsPage />,
  },
  { path: '/internal-support', element: <InternalSupportPage /> },

  { path: 'imOk', element: <ImOkPage /> },
  { path: 'muster/:id/*', element: <ImOk /> },
  { path: 'startIamOk/*', element: <StartIamOkMessagePage /> },
  {
    // id here is GroupID
    path: 'muster/:imOkId/memberSettings/:id/:memberID',
    element: <IAmOkMemberSettingsPage />,
  },
  { path: 'onCallAlert', element: <OnCallAlertPage /> },
  { path: 'oncall/:id/*', element: <OnCallAlert /> },
  { path: 'startOnCallAlert/*', element: <StartOnCallAlertMessagePage /> },
  {
    // id here is GroupID
    path: 'oncall/:onCallAlertId/memberSettings/:id/:memberID',
    element: <OnCallAlertMemberSettingsPage />,
  },
  { path: '/createMessage', element: <CreateMessage /> },
  { path: '/sidebar', element: <Sidebar /> },
  { path: 'sidebar/dev-options', element: <DevOptions /> },
  { path: 'sidebar/settings', element: <Settings /> },
  { path: 'sidebar/support', element: <Support /> },
  { path: 'sidebar/language', element: <Language /> },
  { path: 'sidebar/test-alarm', element: <TestAlarmPage /> },
  { path: 'sidebar/enable-not-available-mode', element: <SetAvailability /> },
  { path: '/createMessage/new', element: <CreateMessageNew /> },
  { path: 'news', element: <NewsPage /> },
  { path: '/message/:id', element: <ChatMessages /> },
  {
    path: '/message/recipient-groups',
    element: <RecipientGroups />,
  },
  {
    path: '/message/:id/fromHoldingStatement',
    element: <ChatMessagesFromHoldingStatement />,
  },
  {
    path: 'message/:id/fromHoldingStatement/read-receipts/:replyId',
    element: <ReadReceiptsPage />,
  },

  {
    path: '/message/:id/fromHoldingStatement/forward/',
    element: <ForwardPage fromHoldingStatement />,
  },
  {
    path: 'message-details/:chatID/memberSettings/:memberID',
    element: <ChatMemberSettings />,
  },
  {
    path: 'message/:chatID/read-receipts/:replyId/memberSettings/:memberID',
    element: <ChatMemberSettings />,
  },
  {
    path: 'message-details/:chatID/fromHoldingStatement/memberSettings/:memberID',
    element: <ChatMemberSettings fromHoldingStatement />,
  },
  { path: '/message-details/:id', element: <ChatDetailsPage /> },
  {
    path: '/message-details/:id/fromHoldingStatement',
    element: <ChatDetailsFromHoldingStatementPage />,
  },
  { path: '/message-details/:id/addGroups', element: <ChatAddGroupsPage /> },
  { path: 'checklists', element: <ChecklistsPage /> },
  { path: 'checklists/create/:checklistName?', element: <CreateChecklistPage /> },
  { path: 'checklists/new/:checklistName?', element: <NewChecklistPage /> },
  { path: 'checklist/:id/edit', element: <EditChecklistPage /> },
  { path: 'checklist/:id', element: <ChecklistPage /> },
  { path: 'checklist/:id/start/:checklistName?', element: <StartChecklistPage /> },
  { path: 'checklist/:id/edit-access', element: <ChecklistEditAccess /> },
  { path: '/holding-statement', element: <HoldingStatementPage /> },
  {
    path: '/createHoldingStatement/*',
    element: <CreateHoldingStatementPage />,
  },
  { path: '/log-notes', element: <LogNotesPage /> },
  { path: '/log-note/:id', element: <LogNotePage /> },
  { path: 'log-note/:id/forward', element: <ForwardPage fromLogNote /> },
  { path: '/log-note/new', element: <CreateLogNotePage /> },
  { path: 'broadcast', element: <BroadcastPage /> },
  { path: 'broadcast/new', element: <BroadcastNewPage /> },
  { path: 'broadcast/recipient-accounts', element: <RecipientGroups /> },
  { path: '/message/:id', element: <ChatMessages /> },
  { path: '/message-details/:id', element: <ChatDetailsPage /> },
  {
    path: '/message-details/:id/addRecipients',
    element: <ChatAddGroupsPage />,
  },
  { path: 'alarm', element: <AlarmPage /> },
  { path: 'alarm/selectGroup', element: <AlarmSelectGroupPage /> },
  { path: 'alarm/alarmCustomText', element: <AlarmCustomTextPage /> },
  { path: 'alarm/map', element: <AlarmMapPage /> },
  { path: 'cec', element: <ExternalContactsPage /> },
  { path: 'cec/:id/*', element: <ExternalContactMessagePage /> },
  { path: 'createCecMessage/*', element: <CreatCecMessagePage /> },
  { path: 'panic/create', element: <PanicAlarmCreatePage /> },
  { path: 'panic/create/select-recipients', element: <PanicSelectRecipientsPage /> },
  { path: 'panic/timer', element: <PanicAlarmTimerPage /> },
];

const routes: RouteObject[] = [
  {
    loader: allRoutesLoader,
    element: (
      <App>
        <RequireCookies>
          <OpenMobileApp>
            <CheckAppAvailable>
              <ErrorHandler>
                <Outlet />
              </ErrorHandler>
            </CheckAppAvailable>
          </OpenMobileApp>
        </RequireCookies>
      </App>
    ),
    children: [
      {
        loader: publicRouteLoader,
        element: (
          <LoaderSplash>
            <PublicRouteRedirector>
              <Outlet />
            </PublicRouteRedirector>
          </LoaderSplash>
        ),
        children: publicRoutes,
      },
      {
        element: (
          <LoaderSplash>
            <AuthRouteRedirector>
              <AuthApp>
                <MapTypeContextProvider>
                  <Outlet />
                </MapTypeContextProvider>
              </AuthApp>
            </AuthRouteRedirector>
          </LoaderSplash>
        ),
        loader: authRouteLoader,
        children: authRoutes,
      },
    ],
  },
];

function LoaderSplash({ children }: { children: React.ReactNode }) {
  const data = useLoaderData() as { loaderResolved: Promise<boolean> };

  return (
    <Suspense fallback={<Splash />}>
      <Await resolve={data.loaderResolved}>{() => children}</Await>
    </Suspense>
  );
}

async function allRoutesLoader({ request }: LoaderFunctionArgs) {
  initAppRegion(request);
  return null;
}

async function publicRouteLoader({ request }: LoaderFunctionArgs) {
  return defer({ loaderResolved: runPublicRouteLoader(request) });
}

function PublicRouteRedirector({ children }: { children: React.ReactElement }) {
  const userId = useAppSelector(selectUserId);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (userId) {
      const destination = location.state?.from?.pathname || '/dashboard';
      // On Electron (HashRouter), React Router's deferred navigation does not update
      // window.location, so single-use ULF tokens linger in the hash after exchange,
      // causing logout in case the user reloads the application.
      // Calling replaceState directly to the destination cleans the URL atomically;
      // the subsequent navigate() call aligns React Router's internal state.
      // This could be react router v6-specific and might be solvable by upgrading.
      if (isElectron()) {
        window.history.replaceState(null, '', `${window.location.pathname}#${destination}`);
      }
      navigate(destination, { replace: true });
    }
  }, [location.state?.from?.pathname, navigate, userId]);

  if (userId) {
    return null;
  }

  return children;
}

function AuthRouteRedirector({ children }: { children: React.ReactElement }) {
  const userId = useAppSelector(selectUserId);
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (!userId) {
      const redirectTo = location.pathname === '/sidebar' ? '/' : location;
      navigate('/login', { state: { from: redirectTo }, replace: true });
    }
  }, [location, navigate, userId]);

  // Clear a stale add-org marker left behind when the user aborts the ULF
  // flow (e.g. hits browser back from the external login page). The
  // successful-return path already clears it inside registerActiveTenantSession.
  useEffect(() => {
    if (userId != null && getPreAddOrgTenantId() != null) {
      clearPreAddOrgTenantId();
    }
  }, [userId]);

  if (!userId) {
    return null;
  }

  return children;
}

async function authRouteLoader({ request }: LoaderFunctionArgs) {
  return defer({ loaderResolved: runAuthRouteLoader(request) });
}

function initAppRegion(request: Request) {
  const url = new URL(request.url);
  const region = resolveAppRegion({
    regionParam: url.searchParams.get('region'),
    storedRegion: getItem('selectedRegion'),
    tokenIssuingUrl: safeParseJwtPayload(getItem('coreApiRefreshToken') ?? '')?.issuingUrl ?? null,
    hasAuthSession: !!getItem('coreApiSessionId'),
  });

  if (!region) {
    return;
  }

  setRegion(region);
  changeBaseUrl(getResolvedApiUrl(region));
}

export const router = isElectron() ? createHashRouter(routes) : createBrowserRouter(routes);

// Expose imperative navigation to early-loading non-React modules (slices, api
// client) without them importing this route tree — see routes/navigation.ts.
registerNavigate(to => router.navigate(to));
